// extracted by mini-css-extract-plugin
export default {"base":"PdfPrintReport_base__y45xZ","pageBreak":"PdfPrintReport_pageBreak__EnsR9"};